import { Dropdown } from '@cmsgov/ds-medicare-gov';
import { ComponentProps } from 'react';
import translate from '../functions/translate';

type SuffixDropdownProps = Pick<ComponentProps<typeof Dropdown>, 'onChange' | 'value'>

export default function SuffixDropdown(props: SuffixDropdownProps) {
    const suffixOptions = [
        {label: translate('none'), value: ''},
        {label: 'Jr', value: 'Jr'},
        {label: 'Sr', value: 'Sr'},
        {label: 'I', value: 'I'},
        {label: 'II', value: 'II'},
        {label: 'III', value: 'III'},
        {label: 'IV', value: 'IV'},
        {label: 'V', value: 'V'},
        {label: 'VI', value: 'VI'},
        {label: 'VII', value: 'VII'},
    ];

    return <>
        <Dropdown
            label={translate('suffix')}
            name={'suffix'}
            options={suffixOptions}
            {...props}
        />
    </>;
}
